<template>
  <right-structure :Pdatas='infoData'>
  </right-structure>
</template>

<script>
  import structure from "@/components/flowStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: null,
        responseCode: null,
        infoData: {
          flow: [
            {
              name: '说明',
              desc: [
                '1、电子优惠券说明',
                {preData: '车场管理方向商户售卖优惠券，商户发放给车主，可用于抵扣停车费。'},
                '2、支持以下优惠方式:',
                {
                  preData: "1) 免费券：当次停车免费",
                },
                {
                  preData: "2) 金额扣减券：减免一定金额的停车费（优惠5元）",
                },
                {
                  preData: "3) 金额折扣券：减免一定折扣的停车费（停车9折）",
                },
                {
                  preData: "4) 金额固定值券：固定收费（1分钱停车）",
                },
                {
                  preData: "5) 时间券：减免停车时间（免费停车3小时）",
                },

              ],
            },
            {
              name: '电子券对接流程',
              desc: [
                '1、取得商家代码',
                {preData: '从我方停车运营管理平台创建对应的商家并取得商家代码'},
                '2、电子券创建、售卖、发放',
                [
                  {
                    preData: "A)获取销售ID，第三方系统自行判断己方是否已经有已创建售卖的电子券模板，若已有，则通过调起我方接口 ",
                    link:  " 查询电子券",
                    url: "queryCoupon",
                    endData: " 获取电子券模板信息进而取得销售ID；"
                  },
                  {
                    preData: "否则，接入我方接口",
                    link:  " 创建电子券模板并售卖给商家",
                    url: "createCoupon",
                    endData: " 创建电子券模板并售卖给相应的商家，取得同步放回的销售ID；"
                  },
                ],
                {
                  preData: "B)发放电子券，接入我方接口",
                  link:  " 发放电子券",
                  url: "sendCoupon",
                  endData: " 将券发放给相应的车主；"
                },

              ],
              url: '/static/img/电子券对接流程.svg'
            },
          ],
        }
      }
    },
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/couponFlow.vue